export function compare(a, b, property, caseInsensitive = false) {
  const aProperty = caseInsensitive ? a[property].toUpperCase() : a[property];
  const bProperty = caseInsensitive ? b[property].toUpperCase() : b[property];

  if (aProperty < bProperty) {
    return -1;
  }
  if (aProperty > bProperty) {
    return 1;
  }
  return 0;
}

export function sortObject(obj, property) {
  const orderedValues = Object.values(obj).sort((a, b) => compare(a, b, property));
  const returnedObj = {};

  orderedValues.forEach((value) => {
    returnedObj[property] = value;
  });

  return returnedObj;
}

export function removePropertyRecursive(obj, propertyList) {
  const changedObj = obj;
  for (const prop in changedObj) {
    for (const property of propertyList) {
      if (prop === property) {
        delete changedObj[prop];
      } else if (typeof changedObj[prop] === 'object') {
        removePropertyRecursive(changedObj[prop], propertyList);
      }
    }
  }
}

export function setStorageWithTtl(key, valueToStore, timeToLive, inSession = false) {
  const now = new Date().getTime();
  const objectToStore = {
    value: valueToStore,
    expires_in: now + timeToLive,
  };
  if (inSession) sessionStorage.setItem(key, JSON.stringify(objectToStore));
  else localStorage.setItem(key, JSON.stringify(objectToStore));
}

export function getStorageWithTtl(key) {
  const now = new Date().getTime();
  let storedObject = localStorage.getItem(key);
  if (!storedObject) storedObject = sessionStorage.getItem(key);
  if (!storedObject) return null;

  storedObject = JSON.parse(storedObject);
  if (storedObject.expires_in > now) return storedObject.value;

  localStorage.removeItem(key);
  return null;
}

export function objectFlip(obj) {
  return Object.entries(obj).reduce((ret, entry) => {
    const [key, value] = entry;
    ret[value] = key;
    return ret;
  }, {});
}

export default null;
